import type { SVGProps } from 'react';

const base: SVGProps<SVGSVGElement> = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.9,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  width: 18,
  height: 18,
};
type P = SVGProps<SVGSVGElement>;
const I = (d: string) => (p: P) => (
  <svg {...base} {...p}>
    <path d={d} />
  </svg>
);

export const Plus = I('M12 5v14M5 12h14');
export const Brush = I('M9.5 14.5 4 20s2.5 1 4 0 1.5-3.5 1.5-3.5M14 4l6 6-7.5 7.5-6-6L14 4Z');
export const Eraser = I('m16 4 4 4-9 9H7l-3-3 9-9ZM5 20h14');
export const Dropper = I('m12 9 3 3M19.5 3.5a2.1 2.1 0 0 0-3 0L14 6l-1.5-1.5-2 2L12 8 4 16v4h4l8-8 1.5 1.5 2-2L18 10l2.5-2.5a2.1 2.1 0 0 0 0-3Z');
export const Undo = I('M9 14 4 9l5-5M4 9h11a5 5 0 0 1 0 10h-3');
export const Redo = I('m15 14 5-5-5-5M20 9H9a5 5 0 0 0 0 10h3');
export const Fill = I('M7 3v6l6 6 6-6-6-6M5 13l6 6M3 21h6');
export const Trash = I('M3 6h18M8 6V4h8v2m-9 0 1 14h8l1-14');
export const Archive = I('M3 8h18v12H3zM3 4h18v4H3zm6 8h6');
export const Copy = I('M9 9h11v11H9zM5 15V4h11');
export const Pencil = I('M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z');
export const Arrow = I('M5 12h14m-6-6 6 6-6 6');
export const Download = I('M12 3v12m0 0 4-4m-4 4-4-4M5 21h14');
export const Upload = I('M12 21V9m0 0 4 4m-4-4-4 4M5 3h14');
export const X = I('M6 6l12 12M18 6 6 18');
export const Sun = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5M17.5 17.5 19 19M19 5l-1.5 1.5M6.5 17.5 5 19" />
  </svg>
);
export const Moon = I('M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z');
export const Contrast = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 3v18Z" fill="currentColor" />
  </svg>
);
export const Grid = I('M4 4h16v16H4zM4 9h16M4 15h16M9 4v16M15 4v16');
